import React from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Upload as UploadIcon } from "@mui/icons-material";

/**
 * Dialog para importar CSV de categorías + Snackbar para notificaciones.
 * Extraído de CategoryReviewPage para mantener la página ≤500L (P7).
 */

interface CategoryReviewImportDialogProps {
  open: boolean;
  onClose: () => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  importing: boolean;
  importResult: any;
  onImport: (file: File) => void;
}

export function CategoryReviewImportDialog({
  open,
  onClose,
  fileInputRef,
  importing,
  importResult,
  onImport,
}: CategoryReviewImportDialogProps): React.ReactElement {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Importar CSV de Categorias</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            El CSV debe tener columnas: unified_product_id, unified_category.
            Las categorias importadas se marcaran como "manual" y no seran
            sobreescritas por el pipeline.
          </Typography>
          <input
            type="file"
            accept=".csv"
            ref={fileInputRef}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) onImport(file);
            }}
            style={{ display: "none" }}
          />
          <Button
            variant="contained"
            size="small"
            onClick={() => fileInputRef.current?.click()}
            disabled={importing}
            startIcon={
              importing ? <CircularProgress size={16} /> : <UploadIcon />
            }
          >
            {importing ? "Importando..." : "Seleccionar archivo CSV"}
          </Button>
          {importResult && !importResult.error && (
            <Alert severity="success">
              Filas procesadas: {importResult.totalRows} | Actualizadas:{" "}
              {importResult.updated}
              {(importResult.parseErrors?.length > 0 ||
                importResult.updateErrors?.length > 0) && (
                <Typography variant="caption" display="block">
                  Errores de parseo: {importResult.parseErrors?.length || 0},
                  Errores de update: {importResult.updateErrors?.length || 0}
                </Typography>
              )}
            </Alert>
          )}
          {importResult?.error && (
            <Alert severity="error">{importResult.error}</Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
